if (!customElements.get('recommendations-products')) {
  class RecommendationsViewed extends customElements.get('card-product-slider') {
    constructor() {
      super();

      this.section = this.closest('.js-section');
      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.wrapper = this.closest('.product-recommendations-wrapper');

      this.fetchRecentProducts();
    }

    async fetchRecentProducts() {
      if (this.sliderWrapper?.children.length) return;

      const url = this.wrapper?.dataset?.url;
      if (!url) return;

      try {
        const response = await fetch(url);
        if (!response.ok) return;

        const html = await response.text();

        const temp = document.createElement('div');
        if (!temp)
          return;
        temp.innerHTML = html;

        const slides = temp.querySelectorAll('.swiper-slide');

        if (!slides.length) return;

        slides.forEach(slide => {
          this.sliderWrapper.append(slide);
        });

        this.initSlider();
        this.section?.classList.remove('hidden');

      } catch (e) {
        // console.error(e);
      }
    }
  }

  customElements.define('recommendations-products', RecommendationsViewed);
}
